import axios from 'axios'

// axios默认配置
axios.defaults.timeout = 10000;   // 超时时间

//整理数据,将数据变为json格式的数据
//JSON.stringify()的作用是将 JavaScript 对象转换为 JSON 字符串，而JSON.parse()可以将JSON字符串转为一个对象
axios.defaults.transformRequest = function (data) {
data = JSON.stringify(data);
  return data;
};

// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
  config => {
    //config.data = JSON.stringify(config.data);  
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    //判断是否存在ticket，如果存在的话，则每个http header都加上ticket
	var f = false;
    if(f){
		config.headers.token="token";
		config.headers.name="name";
    }
    //一定要return ，否则不生效
    return config;
  },
  error => {//错误请求做些什么
    return Promise.reject(error.response);
  });

// 路由响应拦截，拦截服务器响应
// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.resultCode=="404") {
        console.log("response.data.resultCode是404")
        // 返回 错误代码-1 清除ticket信息并跳转到登录页面
//      cookie.del("ticket")
//      window.location.href='http://login.com'
        return
    }else{
        return response;
    }
  },
  error => {
    return Promise.reject(error.response)   // 返回接口返回的错误信息
  });

export default axios;